/**
 * Legacy page → redesigned twin, for DesignRouteGuard. The key is the page
 * segment (`/:brand_name/<page>/…`), the value its replacement.
 *
 * `exact`: only the bare page is redirected, not its child routes —
 *   /reservation/service-booking (already the redesigned barber booking) and
 *   /reservation/verify-reservation stay; /products/product-details/:id and
 *   the products sub-category pages have no shop twin.
 * `keepDistributors`: DistributorLogin brands stay on the legacy page in
 *   both modes (new-checkout has no distributor handling).
 */
export interface DesignTwin {
  twin: string;
  exact?: boolean;
  keepDistributors?: boolean;
  /** query parameters added on the twin (kept ones win) */
  query?: { [key: string]: string };
}

export const DESIGN_TWINS: { [page: string]: DesignTwin } = {
  menu: { twin: 'new-menu' },
  'app-menu': { twin: 'app-new-menu' },
  'dine-in': { twin: 'new-dine-in' },
  checkout: { twin: 'new-checkout', keepDistributors: true },
  guest: { twin: 'new-guest-checkout', keepDistributors: true },
  reservation: { twin: 'new-reservation', exact: true },
  products: { twin: 'shop', exact: true },
  // loyalty: the redesigned rewards page covers joining (signed out) and the
  // customer's rewards, points history and referrals (signed in)
  'join-reward': { twin: 'rewards' },
  'my-rewards': { twin: 'rewards', query: { view: 'my-rewards' } },
  // gift cards: buy, redeem and history on one redesigned page
  giftcard: { twin: 'gift-cards' },
};
